import { useFetcher, useParams } from "react-router-dom";
import PageLabelDisplay from "routes/lens-editor/page-labels/PageLabelDisplay";
import { usePageLabelIdLoader } from "loaders/page-labels.loader";
import { P } from "theme/typography";
import theme from "theme";
import CopyToClipboard from "components/CopyToClipboard";
import { ConfirmationDialogContext } from "contexts/ConfirmationDialogContext";
import { Box } from "@mui/material";
import { useContext } from "react";

const PageLabelRoute = () => {
  const params = useParams();
  const pageLabelId = parseInt(params.pageLabelId || "");
  const pageLabel = usePageLabelIdLoader(pageLabelId);
  const fetcher = useFetcher();
  const confirmCtx = useContext(ConfirmationDialogContext);
  const onDelete = () => {
    if (pageLabel) {
      confirmCtx.confirm({
        title: `Delete Page Label`,
        prompt: <P variant="sm">Are you sure you want to delete {pageLabel.label.name}?</P>,
        callback: () => {
          return Promise.resolve(
            fetcher.submit(
              {
                pageLabelId,
                intent: "delete",
              },
              {
                encType: "application/json",
                method: "POST",
                action: `/lens-editor/${params.lensId}/page-labels`,
              }
            )
          );
        },
      });
    }
  };

  return pageLabel ? (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <Box sx={{ display: "flex", mb: 2, alignItems: "center" }}>
        <P variant="lgBold">{pageLabel.label.name}</P>
        <P variant="lg" sx={{ color: theme.palette.grey["400"], ml: 2 }} title="Page Label ID">
          {pageLabel.label.id}
        </P>
        <CopyToClipboard text={`${pageLabel.label.id}`} title="Copy Page Label ID to Clipboard" />
      </Box>
      <PageLabelDisplay label={pageLabel.label} rules={pageLabel.rules} onDelete={onDelete} sx={{ height: "100%" }} />
    </Box>
  ) : (
    <></>
  );
};

export default PageLabelRoute;
